/* ==========================================================================
   Ads-Angebot 250er — 8 Hefte Longpapers gratis (v1.1.0, 17.10.2026: Zeitfenster)
   Entscheid Gianluca 22.09.2026 · Lagebild „Ads-Angebot 250er" · Projekt
   ~/Documents/Claude/Projects/meta-ads-angebot-250/README.md

   Regel: Hat der Warenkorb das Attribut ads_angebot=250 (gesetzt NUR von der
   Ads-Landingpage) UND eine 250er Aktivkohlefilter (jede Farbe), liegen genau
   8 Hefte Longpapers als 0-€-Geschenk darin. Farbe = Filterfarbe, oder die
   Wahl aus dem Attribut ads_papers (ORGANIC|VIOLET|SUNSET|ROSÉ). ads_papers=none
   heisst: Kunde hat das Geschenk bewusst entfernt → nicht wieder einlegen.

   GETRENNT von der Geschenkleiter (cart-gift-tiers.js): eigener Marker
   _ads_angebot, NICHT _gift. Die Leiter fasst diese Zeilen nie an, und mit
   0 € zählen sie nicht zu ihrer Schwelle.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__adsAngebot250) return;

  var CFG = {
    attr: 'ads_angebot',
    attrValue: '250',
    papersAttr: 'ads_papers',
    marker: '_ads_angebot',
    qty: 8,
    // 250er-Variante → Farbe
    filters: {
      52444877062410: 'ORGANIC',
      52444877095178: 'VIOLET',
      52444877127946: 'SUNSET',
      52444877160714: 'ROSÉ'
    },
    // Farbe → Geschenk-Variante (Zuordnung Gianluca 22.09.: SUNSET=Hemp MLP1H, ROSÉ=Rosé MLP1P)
    gifts: {
      'ORGANIC': 53787504607498,
      'VIOLET': 53787505459466,
      'SUNSET': 53787505492234,
      'ROSÉ': 53787505525002
    }
  };
  var GIFT_IDS = Object.keys(CFG.gifts).map(function (k) { return CFG.gifts[k]; });
  // Zeitfenster (v1.1.0, 17.10.2026, Entscheid E1 Gianluca 16.10.2026): Das Angebot gilt bis
  // So 15.11.2026 17:30 und Di 01.12.2026 00:00 bis Fr 18.12.2026 23:59 (MEZ). Ausserhalb legt
  // die Regel nichts ein und nimmt vorhandene Papers-Zeilen heraus. Gleiche Zeitstempel wie in
  // sections/ads-angebot-250.liquid. Neues Fenster = neuer Entscheid + Lagebild + Zeile hier.
  var AA250_FENSTER = [[0, 1794760200000], [1796079600000, 1797634800000]];
  function imFenster(t) {
    t = t || Date.now();
    return AA250_FENSTER.some(function (w) { return t >= w[0] && t < w[1]; });
  }
  var SS_KEY = 'adsA250_present';
  var busy = false;
  var queued = false;

  function log() {
    if (window.localStorage && localStorage.getItem('adsA250_debug')) {
      console.log.apply(console, ['[ADS250]'].concat([].slice.call(arguments)));
    }
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.ok ? r.json() : r.json().then(function (e) { throw e; });
    });
  }

  function bundledSections() {
    var ev = new CustomEvent('cart:prepare-bundled-sections', { detail: { sections: [] }, bubbles: true });
    document.dispatchEvent(ev);
    return ev.detail.sections.join(',');
  }

  // Wie cart-gift-tiers.js: frischen Cart MIT sections holen und an Impact geben.
  function refreshDrawer() {
    return post('/cart/update.js', { sections: bundledSections(), sections_url: window.location.pathname })
      .then(function (cart) {
        if (cart && cart.sections) {
          document.dispatchEvent(new CustomEvent('cart:change', {
            detail: { cart: cart, quantity: 0, sections: cart.sections, adsA250: true }, bubbles: true
          }));
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { adsA250: true } }));
        if (/^\/cart\/?$/.test(window.location.pathname)) window.location.reload();
      })
      .catch(function () { document.dispatchEvent(new CustomEvent('cart:refresh')); });
  }

  function desiredGift(cart) {
    if (!imFenster()) return null;
    var attrs = cart.attributes || {};
    if (attrs[CFG.attr] !== CFG.attrValue) return null;
    var choice = attrs[CFG.papersAttr] || 'auto';
    if (choice === 'none') return null;
    var best = null;
    (cart.items || []).forEach(function (it) {
      var color = CFG.filters[it.variant_id];
      if (color && (!best || it.quantity > best.quantity)) best = { color: color, quantity: it.quantity };
    });
    if (!best) return null;
    var color = CFG.gifts[choice] ? choice : best.color;
    return CFG.gifts[color];
  }

  // pass > 0 = Kontrolldurchlauf nach einer eigenen Aenderung (max. 3), faengt
  // Ueberschneidungen mit Theme-/Leiter-Aenderungen ab (im Test: kurz zwei Sets).
  function reconcile(pass) {
    pass = pass || 0;
    if (busy) { queued = true; return; }
    busy = true;
    var didChange = false;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var want = desiredGift(cart);
        var lines = (cart.items || []).filter(function (it) { return GIFT_IDS.indexOf(it.variant_id) !== -1; });
        var present = lines.some(function (l) { return l.variant_id === want; });

        // Kunde hat das Geschenk selbst entfernt → respektieren (ads_papers=none).
        var hadIt = sessionStorage.getItem(SS_KEY);
        if (want && !present && lines.length === 0 && hadIt && String(want) === hadIt) {
          log('opt-out erkannt');
          sessionStorage.removeItem(SS_KEY);
          var a = {}; a[CFG.papersAttr] = 'none';
          return post('/cart/update.js', { attributes: a });
        }

        var updates = {};
        var changed = false;
        lines.forEach(function (l) {
          if (l.variant_id !== want) { updates[l.key] = 0; changed = true; }
          else if (l.quantity !== CFG.qty) { updates[l.key] = CFG.qty; changed = true; }
        });

        var p = Promise.resolve();
        if (changed) { log('updates', updates); p = p.then(function () { return post('/cart/update.js', { updates: updates }); }); }
        if (want && !present) {
          log('add', want);
          var props = {}; props[CFG.marker] = '250er';
          p = p.then(function () {
            return post('/cart/add.js', { items: [{ id: want, quantity: CFG.qty, properties: props }] });
          });
          changed = true;
        }
        // Nur merken, was TATSAECHLICH im Warenkorb gesehen wurde — sonst haelt ein
        // fehlgeschlagenes Einlegen sich beim naechsten Lauf fuer ein Opt-out.
        if (want && present) sessionStorage.setItem(SS_KEY, String(want));
        else if (!want) sessionStorage.removeItem(SS_KEY);
        didChange = changed;
        return p.then(function () { if (changed) return refreshDrawer(); });
      })
      .catch(function (e) { log('fehler', e); })
      .then(function () {
        busy = false;
        if (didChange && pass < 3) { setTimeout(function () { reconcile(pass + 1); }, 400); return; }
        if (queued) { queued = false; setTimeout(function () { reconcile(0); }, 50); }
      });
  }

  var t = null;
  function schedule(ev) {
    if (ev && ev.detail && ev.detail.adsA250) return; // eigene Events nicht erneut verarbeiten
    clearTimeout(t);
    t = setTimeout(reconcile, 250);
  }

  // Oeffentliche Schnittstelle fuer die Landingpage.
  window.__adsAngebot250 = {
    config: CFG,
    imFenster: imFenster,
    reconcile: reconcile,
    // Setzt die Ads-Markierung (und optional die Papers-Farbe) im Warenkorb.
    activate: function (papers) {
      var a = {}; a[CFG.attr] = CFG.attrValue;
      if (papers) a[CFG.papersAttr] = papers;
      return post('/cart/update.js', { attributes: a }).then(function (c) { reconcile(); return c; });
    }
  };

  ['cart:change', 'cart:refresh', 'cart:updated'].forEach(function (n) { document.addEventListener(n, schedule); });
  window.addEventListener('pageshow', function () { schedule(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { schedule(); });
  else schedule();
})();
